<template>
	<DataTable
		class="p-component p-shadow-2"
		:value="tablePositionTrainingValues"
		:autoLayout="true"
		:rowHover="true"
		@row-click="onMarkRegion"
		:loading="loading"
	>
		<template #loading>
			{{  $t('Squeeze.General.Loading') }}
		</template>
		<template #empty>
			{{  $t('Squeeze.General.NoEntriesFound', { entryName: $t('Squeeze.Validation.General.Position') }) }}
		</template>
		<Column field="id" header="ID" headerClass="header-center" style="width:3rem; text-align: center;" />
		<Column field="columnName" :header="$t('Squeeze.Training.Column')" />
		<Column field="valuePattern" :header="$t('Squeeze.Locators.PatternValue')" />
		<template v-if="clickOnTestingButton">
			<Column field="columnHits" header="Hits" headerClass="header-center" style="width:3rem; text-align: center;" />
		</template>
		<Column style="min-width: 7rem; text-align: right;">
			<template #body="slotProps">
				<Button v-tooltip="$t('Squeeze.Locators.Edit')" icon="mdi mdi-pencil-outline" class="p-button p-component p-button-icon-only p-button-lg p-button-rounded p-button-success p-button-text" @click="changeTrainingRow(slotProps.data)"/>
				<Button v-tooltip="$t('Squeeze.Validation.Buttons.Delete')" icon="mdi mdi-delete-outline" class="p-button p-button-rounded p-button-danger p-button-text deleteButtonRow" @click="deleteTrainingRow(slotProps.data)"/>
			</template>
		</Column>
	</DataTable>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {useI18n} from "vue-i18n";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {PositionTrainingWithName} from "@/apps/squeeze/views/PositionTraining.vue";
import {TableColumnTraining} from "@dex/squeeze-client-ts";

export default defineComponent({
	name: "DocumentPositionTrainingTable",
	components: {
		Button,
		DataTable,
		Column,
	},
	props: {
		tablePositionTrainingValues: {
			type: Array as PropType<PositionTrainingWithName[]>,
			default: () => [],
		},
		clickOnTestingButton: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	emits: [
		'changeTrainingRow',
		'deleteTrainingRow',
		'onMarkRegion',
	],
	setup(props, {emit}) {
		const {t} = useI18n();

		/**
		 * Change a training value
		 * @param {TableColumnTraining} rowData
		 */
		const changeTrainingRow = (rowData: TableColumnTraining) => {
			emit("changeTrainingRow", rowData);
		}

		/**
		 * Deletes a row of the training table
		 * @param {TableColumnTraining} rowData
		 */
		const deleteTrainingRow = (rowData: TableColumnTraining) => {
			emit("deleteTrainingRow", rowData);
		}

		/**
		 * Click a testing row to mark
		 * @param event
		 */
		const onMarkRegion = (event: any) => {
			emit("onMarkRegion", event);
		}

		return {
			t,
			changeTrainingRow,
			deleteTrainingRow,
			onMarkRegion,
		}
	},
});
</script>

<style scoped>

::v-deep(.header-center div.p-column-header-content) {
	justify-content: center;
}

</style>
